import { AppState, useAppSelector } from '@redux/store';

export const useCurrentUser = () =>
  useAppSelector(({ auth, users }: AppState) => {
    if (auth.user?.id) {
      return users.byId[auth.user?.id];
    }

    return null;
  });

export const useUserDataById = (userId?: string | null) =>
  useAppSelector(({ users }: AppState) => {
    if (!userId) {
      return null;
    }

    return users.byId[userId] || null;
  });
